import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: "",
    profile: null,
    rights: [],
  },
  reducers: {
    updateToken(state, action) {
      state.token = action.payload;
    },
    updateProfile(state, action) {
      state.profile = action.payload;
    },
    updateRights(state, action) {
      state.rights = action.payload;
    },
    logoutUser(state) {
      state.token = "";
      state.profile = null;
      state.rights = [];
    },
  },
});

export const { updateToken, updateProfile, updateRights, logoutUser } =
  authSlice.actions;
export default authSlice.reducer;
